import { useParams, Link } from 'react-router-dom'
import { useSnapshot } from 'valtio'
import styled from 'styled-components'
import { portalState } from '../../hooks/usePortal'
import useTranslation from '../../hooks/useTranslation'
import { Icon_Invoice, Icon_PeopleGroup, Icon_StockMovement } from '../../styles/icons'
import { RiUserAddLine } from 'react-icons/ri'

const Page = styled.div`
    padding: 2rem 1.5rem;
    max-width: 720px;
`

const Greeting = styled.h2`
    margin: 0 0 0.25rem 0;
    font-size: 1.75rem;
    font-weight: 700;
`

const Subtitle = styled.p`
    margin: 0 0 2rem 0;
    font-size: 1rem;
    color: ${({ theme }) => theme.font?.muted || '#6b7280'};
`

const SectionTitle = styled.h3`
    margin: 0 0 1rem 0;
    font-size: 0.875rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${({ theme }) => theme.font?.muted || '#6b7280'};
`

const CardGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 1rem;
`

const NavCard = styled(Link)`
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 1.25rem;
    background: ${({ theme }) => theme.area?.background || '#fff'};
    border: 1px solid ${({ theme }) => theme.border?.color || '#e5e7eb'};
    border-radius: 0.75rem;
    text-decoration: none;
    color: inherit;
    transition: border-color 0.15s, box-shadow 0.15s;

    &:hover {
        border-color: ${({ theme }) => theme.btn?.primary || '#2563eb'};
        box-shadow: 0 2px 8px ${({ theme }) => theme.btn?.primary || '#2563eb'}22;
    }
`

const CardIcon = styled.div`
    font-size: 1.5rem;
    color: ${({ theme }) => theme.btn?.primary || '#2563eb'};
    line-height: 1;
`

const CardLabel = styled.span`
    font-size: 0.95rem;
    font-weight: 600;
`

const portalSections = {
    customerPortal: [
        { labelKey: 'portal.nav.invoices',    path: 'invoice',    icon: Icon_Invoice },
        { labelKey: 'portal.nav.creditNotes', path: 'creditNote', icon: Icon_PeopleGroup }
    ],
    supplierPortal: [
        { labelKey: 'portal.nav.orders', path: 'orders', icon: Icon_StockMovement }
    ],
    invitation: [
        { labelKey: 'portal.nav.accept', path: 'accept', icon: <RiUserAddLine /> }
    ]
}

const PortalWelcomePage = () => {
    const { token } = useParams()
    const snap = useSnapshot(portalState)
    const { t } = useTranslation()

    const contactDisplay = snap.contactName || snap.name || ''
    const sections = portalSections[snap.type] || []

    const greeting = contactDisplay
        ? t('portal.welcome.greeting').replace('{name}', contactDisplay)
        : t('portal.welcome.greeting.generic')

    return (
        <Page>
            <Greeting>{greeting}</Greeting>
            <Subtitle>{t(`portal.welcome.subtitle.${snap.type}`)}</Subtitle>
            <SectionTitle>{t('portal.welcome.sections.title')}</SectionTitle>
            <CardGrid>
                {sections.map(({ labelKey, path, icon }) => (
                    <NavCard key={path} to={`/portal/${token}/${path}`}>
                        <CardIcon>{icon}</CardIcon>
                        <CardLabel>{t(labelKey)}</CardLabel>
                    </NavCard>
                ))}
            </CardGrid>
        </Page>
    )
}

export default PortalWelcomePage
